export { TextArea as default } from './TextArea';